import { render, staticRenderFns } from "./rich-html-editor.vue?vue&type=template&id=ab32ec98&"
import script from "./rich-html-editor.vue?vue&type=script&lang=js&"
export * from "./rich-html-editor.vue?vue&type=script&lang=js&"
import style0 from "./rich-html-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports